import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { IEffectModelValCollection } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { TEXT_BASELINE_OFFSET } from '../constants';
import { IBorderInfo } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { IGradFill, IImageFill, IPatternFillStyle } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

/**
 * 定义颜色属性
 */
export interface IColor {
    // eslint-disable-next-line camelcase
    srgb_color: string;
    alpha?: number;
    colorType?: string;
    colorValue?: string;
}

/**
 * text body样式声明
 */
export interface ITextBodyStyle {
    wrapperStyle?: IWrapperStyle;
    bodyStyle?: IBodyStyle;
    autoFitType?: string;
    isEditorModelTempData?: boolean; // 临时标识
}

export interface IWrapperStyle {
    alignItems?: 'flex-start' | 'flex-end' | 'center';
    fontScale?: number;
    textDirection?: TextDirectionType;
    resizeLevel?: number;
    justifyContent?: 'center' | 'start';
    columnNumber?: number;
    columnSpace?: number;
}

export interface IBodyStyle {
    paddingTop?: number;
    paddingLeft?: number;
    paddingRight?: number;
    paddingBottom?: number;
    whiteSpace?: 'pre' | 'pre-wrap';
    width?: 'fit-content' | '100%';
    height?: 'fit-content' | '100%';
    maxWidth?: 'fit-content' | '100%';
    maxHeight?: 'fit-content' | '100%';
    isFlatText?: boolean;
    prstTxWarp?: {
        prst?: number
        avLst?: any
    };
}

export interface ITabstop {
    position: number;
    alignment: 'left' | 'center' | 'right' | 'decimal' | 'bar';
}

/**
 * 段落对齐方式
 */
export enum IParagraphTextAlign {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
    JUSTIFY = 'justify',
    DISTRIBUTE = 'distribute',
}

/**
 * 段落样式声明
 */
export interface IParagraphStyle {
    lang?: string;
    level?: number;
    textAlign?: 'left' | 'center' | 'right' | 'justify' | 'distribute';
    marginLeft?: number;
    textIndent?: number;
    paddingTop?: number; // 段前间距
    paddingBottom?: number; // 段后间距
    // 原始的 paddingTop，这两个字段的存在理由详见 fixParaStyle 的注释
    rawPaddingTop?: number;
    rawPaddingBottom?: number;
    paddingTopIs?: 'absolute' | 'percent';
    paddingBottomIs?: 'absolute' | 'percent';
    lineHeight?: number;
    lineHeightIs?: 'absolute' | 'percent';
    character?: IParagraphCharacter;
    buNone?: number;
    PPTLineHeight?: number;
    tabSize?: number;
    tabList?: ITabstop[];
    defaultRunProps?: ITextRunStyle;
}

export interface IParagraphCharacter {
    buClrTx?: 0 | 1;
    buClr?: { color: ITDColor };
    buSzTx?: 0 | 1;
    buSzPct?: number;
    buSzPts?: number;
    character?: boolean;
    // eslint-disable-next-line camelcase
    character_bullet_char?: string;
    buAutoNum?: { type: string, startAt?: number };
    buBlip?: { blip: { src: string } };
    buNone?: 0 | 1;
    buFont?: { typeface?: string, panose?: string, pitchFamily?: number, charset?: number };
    buFontTx?: 0 | 1;
    raw?: string[];
}

/**
 * text run样式
 */
export interface ITextRunStyle {
    // eslint-disable-next-line camelcase
    fontSize?: number;
    rawFontSize?: number,
    displayFontSize?: number,
    lineHeight?: number,
    lineHeightIs?: 'percent' | 'absolute',
    fontSizeFrom?: 'default' | 'inherit' | 'textrun',
    backgroundColor?: string | null;
    color?: string;
    tdColor?: ITDColor;
    fonts?: { latin?: string, ea?: string, cs?: string, sym?: string};
    fontFamily?: string;
    del?: string;
    letterSpacing?: number;
    textDecoration?: string;
    fontWeight?: string;
    fontStyle?: 'italic' | 'normal';
    href?: any;
    lang?: string,
    effect?: IEffectModelValCollection,
    border?: IBorderInfo,
    [TEXT_BASELINE_OFFSET]?: number;
    useEndParaStyle?: boolean;
    noFill?: number;
    image?: IImageFill | null;
    gradFill?: IGradFill | null;
    pattFill?: IPatternFillStyle | null;
}

export type IAllStyles = ITextRunStyle & IParagraphStyle & IBodyStyle & IWrapperStyle;
